import { useTheme } from "@/app/providers/ThemeProvider";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { useTranslation } from "react-i18next";
import { useAppHref } from "@/utils/appUrl";

export function Hero() {
  const { t } = useTranslation(["landing"]);
  const { mode } = useTheme();
  const registerHref = useAppHref(FRONTEND_ROUTES.auth.registerClinic);

  return (
    <section id="hero" className="bg-primary/5 text-foreground px-6 py-20">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
        {/* TEXT CONTENT */}
        <div className="flex-1 space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            {t("landing:hero_clinic.title")}
          </h1>

          <p className="mt-4 text-lg text-foreground/80">
            {t("landing:hero_clinic.sub_title")}
          </p>

          <div className="flex mt-8 flex-col sm:flex-row items-center gap-4">
            <a
              href={registerHref}
              className="bg-primary text-white px-4 py-2 rounded-full font-medium hover:bg-primary/80 transition"
            >
              {t("landing:hero_clinic.main_action")}
            </a>

            <span className="text-foreground/80 text-sm">
              {t("landing:hero_clinic.no_credit_card")}
            </span>
          </div>
        </div>

        {/* IMAGE / MOCKUP */}
        <div className="flex justify-center">
          <img
            src={
              mode === "dark"
                ? "/images/hero-dark.png"
                : "/images/hero-light.png"
            }
            alt={t("landing:hero_clinic.alt_title")}
            className="w-full max-w-md rounded-xl shadow-lg border border-[#EAEEEA]"
          />
        </div>
      </div>
    </section>
  );
}
